/// <reference path="../_references.ts"/>

module App.Appointments {
	angular
		.module('appointment', [
			'ngMap',
			'user',
			'helpers.bottomDrawer',
			'helpers.locationService',
			'timeEvent',
		])
		.config(['$stateProvider', ($stateProvider: ng.ui.IStateProvider) => {
			$stateProvider
				.state('zipSolutions.home', {
					url: 'home',
					redirectTo: 'zipSolutions.home.appointment',
				})
				.state('zipSolutions.home.appointment', {
					url: '/appointment',
					data: {
						title: 'Appointments',
					},
					views: {
						'content@': {
							controller: 'AppointmentController',
							controllerAs: 'ctrl',
							templateUrl: 'html/appointment/appointment.html',
						},
					},
					params: {
						completedApptId: null,
					},
				})
				.state('zipSolutions.home.appointment.overview', {
					url: '/overview',
					data: {
						title: 'Appointment Overview',
					},
					views: {
						'content@': {
							controller: 'AppointmentOverviewController',
							controllerAs: 'ctrl',
							templateUrl: 'html/appointment/appointment-overview.html',
						},
					},
				});
		}])
		.factory('AppointmentService', AppointmentService.factory())
		.factory('SelectedAppointment', SelectedAppointment.Factory())
		.controller('AppointmentController', AppointmentController)
		.controller('AppointmentOverviewController', AppointmentOverviewController)
		.controller('AppointmentMenuController', AppointmentMenuController)
		.filter('menuDisplayFilter', ['$state', ($state: ng.ui.IStateService) => {
			return (items: MenuItem[], appointment: Appointment) => {
				return items.filter((item: MenuItem) => {
					if (item.displayKeys === false || item.displayKeys === true) {
						return item.displayKeys;
					}

					let keys: string[] = <string[]>item.displayKeys;

					if (appointment === null || appointment.appointment_status === null) {
						return keys.indexOf("Unselected") >= 0;
					}

					return keys.indexOf(appointment.appointment_status) >= 0;
				});
			}
		}]);
}